import {defineStore} from 'pinia';
import { useTourStore } from '../vue/shared/stores/tourStore'
import * as Routes from '../packs/routes';

export const useApplicationStore = defineStore(
    'verify-store',
    {
        state: () => {
            return {
                user: {},
                dashboardPromise: null,
            }
        },

        actions: {
            async dashboard() {
              if (Object.keys(this.user).length > 0) {
                return this.user;
              }

              // Request already running - Vue routes races Dashboard (tour phase vs onMounted).
              if (this.dashboardPromise) {
                return this.dashboardPromise;
              }

              this.dashboardPromise = fetch(Routes.api_v1_dashboard_path())
                .then(res => res.json())
                .then(data => {
                  const userData = data.user
                  this.user = userData
                  return userData
                })
                .finally(() => {
                  this.dashboardPromise = null
                });

              return this.dashboardPromise
            },
          /**
           * Decides whether to show the IFC upload button depending on the user.
           */
          showIfcUpload() {
            const isEvelixia = this.user.email.includes('evelixia')
            const isSircular = this.user.email.includes('sircular')
            return isEvelixia || isSircular;
          }
        }
    }
);